import script from "./SettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./SettingsModal.vue?vue&type=style&index=0&id=d84cec04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d84cec04"]])

export default __exports__